import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import fetch from './fetch';
import dashboard from './dashboard';
import quickpay from './quickpay';

const quickpayPersistConfig = {
  key: 'quickpay',
  storage,
  whitelist: ['uid'],
};

const reducers = (history) => combineReducers({
  router: connectRouter(history),
  dashboard,
  fetch,
  quickpay: persistReducer(quickpayPersistConfig, quickpay),
});

export default reducers;
